export default function ($translate) {
    return {
        KEYS: {
            RECOMMEND_COURSY_2021_MAY: 'RECOMMEND_COURSY_2021_MAY'
        },
        LABELS: {
            RECOMMEND_COURSY_2021_MAY: $translate.instant('userNps.How likely would you recommend Coursy to your colleagues or people in the same profession?')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/nps/questionType/index.js